import { requestConstantsMaker } from '../helper';

/**** 20200217 ****/
export const GET_ALL_COURSE_CATEGORY = requestConstantsMaker('GET_ALL_COURSE_CATEGORY');
export const GET_COURSE_CATEGORY = requestConstantsMaker('GET_COURSE_CATEGORY');
export const CREATE_COURSE_CATEGORY = requestConstantsMaker('CREATE_COURSE_CATEGORY');
export const UPDATE_COURSE_CATEGORY = requestConstantsMaker('UPDATE_COURSE_CATEGORY');
export const GET_COURSE_CATEGORIES_FOR_SELECTION = requestConstantsMaker('GET_COURSE_CATEGORIES_FOR_SELECTION');
export const GET_COURSE_CATEGORIES_FOR_NEW_APPLICATION = requestConstantsMaker('GET_COURSE_CATEGORIES_FOR_NEW_APPLICATION');
/**** 20200217 ****/

export const GET_ALL_COURSE_CATEGORY_BY_SPECIFICATION = requestConstantsMaker('GET_ALL_COURSE_CATEGORY_BY_SPECIFICATION');
export const GET_COURSE_CATEGORY_BY_ID = requestConstantsMaker('GET_COURSE_CATEGORY_BY_ID');
export const POST_CREATE_COURSE_CATEGORY = requestConstantsMaker('POST_CREATE_COURSE_CATEGORY');
export const PUT_UPDATE_COURSE_CATEGORY = requestConstantsMaker('PUT_UPDATE_COURSE_CATEGORY');
// export const GET_COURSE_CATEGORIES_FOR_NEW_APPLICATION = requestConstantsMaker('GET_COURSE_CATEGORIES_FOR_NEW_APPLICATION');